import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import AutoLogout from "./AutoLogout";

const ProtectedRoute = ({ children, requireInternalNavigation = false }) => {
    const location = useLocation();
    const usuario = localStorage.getItem("usuario") || sessionStorage.getItem("usuario");

    // 1. Si no hay sesión iniciada o se cerró sesión, redirigir al Login
    if (!usuario) {
        return <Navigate to="/" replace />;
    }

    // 2. Si se requiere que SOLO se acceda mediante botones/redirecciones internas del sistema
    // (Detecta si la URL fue escrita manualmente directamente en la barra de navegación)
    if (requireInternalNavigation && !location.state?.fromApp) {
        return <Navigate to="/menu" replace />;
    }

    return (
        <>
            <AutoLogout timeoutMinutes={20} />
            {children}
        </>
    );
};

export default ProtectedRoute;
